import { AWFTableColumn } from '@ansys-internal/awf-angular/core';
import { ContributionsEnum } from '../../contributions.enum';
import { TableColumn } from '@ansys-internal/awf-angular/contributions';
import {
  AWCTableCell,
  TableCellAlign,
  TableCellTypes,
} from '@ansys-internal/awc-angular/tables';
import { DriveCycleTableType } from '../../../shared/types/drive-cycle-table.type';

@AWFTableColumn({
  id: ContributionsEnum.DRIVE_CYCLE_TABLE_NUMBER_OF_POINTS_COLUMN,
  priority: 100,
})
export class DriveCycleTableNumberOfPointsColumn implements TableColumn {
  id: string = ContributionsEnum.DRIVE_CYCLE_TABLE_NUMBER_OF_POINTS_COLUMN;
  priority: number = 100;
  align: TableCellAlign = TableCellAlign.LEFT;
  header: string = 'Number of Points';
  type: TableCellTypes = TableCellTypes.TEXT;
  width: number = 130;

  public async render(data: DriveCycleTableType): Promise<AWCTableCell> {
    return { value: data.numberOfPoints };
  }
}
